import fitty from 'fitty';

export default function initFitty() {
    const heading = document.querySelectorAll('h1');

    heading.forEach(el => {
        const elm = el.textContent.split(' ');

        const arr = [];

        elm.forEach(elem => {
            arr.push(Number(elem.length));
        });

        const result = Math.max(...arr);

        if (result >= 12) {
            el.classList.add('fit');
        }
    });

    fitty('.fit', {
        multiLine: true,
        minSize: 25,
        maxSize: 124
    });
}